import { Component, input } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
    selector : 'cco-common-form-validation-messages',
    templateUrl : './common-form-validation-messages.component.html',
    styleUrls: ['./common-form-validation-messages.component.scss'],
    standalone: true,
    imports: [TranslocoModule]
})
export class CommonFormValidationMessagesComponent {

    control = input<AbstractControl | null>( null);
    showErrors = input<boolean>(false);

};